import { ChangeDetectorRef, Component, Inject, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/dialogs/confirm-dialog/confirm-dialog.component';
import { GlobalFunctions } from '@global/GlobalFunctions';
import { DropDownListComponent } from '@syncfusion/ej2-angular-dropdowns';

@Component({
	selector: 'app-complete-action',
	templateUrl: './complete-action.component.html',
	styleUrls: ['./complete-action.component.scss']
})
export class CompleteActionComponent {
	/** Dialog Form */
	dialogForm: FormGroup;
	/** Header Text */
	public headerText: String
	/** dialogText */
	public dialogText: string
	/** Max Comment Length */
	public maxLength = 200;
	/** attachedToEvent */
	public attachedToEvent: boolean = true;

	/** ruleOptions */
	public ruleOptions: { text: string, value: number }[] = [
		{ text: "Re-Enable Rule", value: 1 },
		{ text: "Remind After 30 Days", value: 2 }
	];

	/** ruleFields */
	public ruleFields: { text: string, value: string } = { text: "text", value: "value" };

	/** ruleListFields */
	public ruleListFields: Object = { text: "RuleDescription", value: "RuleID" };

	/** allowDelay */
	public allowDelay: boolean = false;

	/** for refreshing the displayed delay */
	@ViewChild('dropdown') dropdownObj: DropDownListComponent;

	/** ruleList */
	public ruleList: any[] = [];

	/** hideRules */
	public hideRules: boolean = false;

	/**
	 * Constructor
	 * @param fb
	 * @param dialogRef
	 * @param cdr 
	 * @param data
	 * @param globalFunctions 
	 */
	constructor(
		private fb: FormBuilder,
		public dialogRef: MatDialogRef<CompleteActionComponent>,
		private cdr: ChangeDetectorRef,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public globalFunctions: GlobalFunctions
	) {
		this.headerText = data["HeaderText"];
		this.dialogText = data["DialogText"];

		// this.attachedToEvent = data["attachedToEvent"];

		this.ruleList = data["DisabledRules"];

		this.dialogForm = this.fb.group({
			comment: ['', [Validators.required, Validators.maxLength(this.maxLength)]],
			ruleChoice: ['', Validators.required],
			delay: [30]
		});
		this.dialogForm.get("delay")?.disable();

		if (this.ruleList.length == 0) {
			this.hideRules = true;
			this.dialogForm.get("ruleChoice")?.clearValidators();
		}
	}

	/** getCommentLength */
	getCommentLength(): number {
		return this.dialogForm.get('comment')?.value.length || 0;
	}

	/**
	 * Cancel button for dialog
	 */
	onCancelClick(): void {
		if (this.dialogForm.dirty) {
			this.globalFunctions.UserConfirm$('Lose any unsaved changes?').subscribe(OKResult => {
				if (OKResult) { this.dialogRef.close(); }
				// do nothing if result is false
			});	
		} else {
			this.dialogRef.close();
		}
	}

	/**
	 * ruleChoiceChange
	 * @param event event 
	 */
	ruleChoiceChange(event: any) {
		if (event.value == 1) {
			this.dialogForm.get('value1')?.clearValidators();
			this.dialogForm.get("delay")?.disable();
		} else if (event.value == 2) {
			this.dialogForm.get('delay')?.setValidators([Validators.required]);
			this.dialogForm.get("delay")?.enable();
		}
	}

	/**
	 * delayChange
	 * @param event event  
	 */
	delayChange(event: any) {
		this.ruleOptions[1].text = `Remind After ${event.value} Days`;
		this.dropdownObj.refresh();
	}

	/** makeRuleReadable */
	makeRuleReadable(rule: any): string {
		let result: string = "";
		if (rule.RuleDef && rule.RuleDef[0].SI) {
			for (let i: number = 0; i < rule.RuleDef?.length; i++) {
				let SI: string = rule.RuleDef[i].SI;
				if (rule.RuleDef[i].Operator != '~' && rule.RuleDef[i].Operator != '!~') {
					result += SI + rule.RuleDef[i].Operator + rule.RuleDef[i].Limit;
				} else {
					result += SI + " between " + rule.RuleDef[i].Limit + " and " + rule.RuleDef[i].LowerLimit;
				}
				if (i != rule.RuleDef.length - 1) {
					const comp = rule.RuleText.match(/AND|OR/)?.[0] || "";
					result += " " + comp + " ";
				}
			}
			result += " for " + rule.TriggerTime + " minutes";
		} else {
			result = rule.ReadableRule;
		}
		return result;
	}
}
